<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useResume } from '@/composables/useResume'

const { content } = useResume()
const { t } = useI18n()
</script>

<template>
  <section id="experience">
    <div class="wrap">
      <div class="sec-head reveal">
        <div class="eyebrow"><span class="eyebrow-idx">01 /</span> {{ content.sectionTitles.experience }}</div>
        <h2 class="sec-title">{{ t('sections.experienceTitle') }}</h2>
        <p class="sec-sub">{{ content.sectionTitles.experienceSub }}</p>
      </div>
      <div class="timeline">
        <div
          v-for="(item, i) in content.experience"
          :key="i"
          class="tl-item reveal"
          :class="{ current: item.current }"
        >
          <div class="tl-rail"><span class="tl-node"></span></div>
          <div class="tl-period">
            {{ item.period }}
            <div v-if="item.current"><span class="badge">{{ t('experience.current') }}</span></div>
          </div>
          <div class="tl-card glass">
            <div class="tl-company">{{ item.company }}</div>
            <div class="tl-role">{{ item.role }}</div>
            <ul class="tl-points">
              <li v-for="(point, j) in item.points" :key="j">{{ point }}</li>
            </ul>
            <div class="stack">
              <span v-for="(tech, j) in item.stack" :key="j" class="tag">{{ tech }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
